import { createMutationHook, createQueryHook } from "../factory";

const ssoDomainIdentityProviderKeys = {
  all: ["ssoDomainIdentityProviders"] as const,
  lists: () => [...ssoDomainIdentityProviderKeys.all, "list"] as const,
  list: () => [...ssoDomainIdentityProviderKeys.lists()] as const,
};

export const ssoDomainIdentityProviders = {
  getSsoDomainIdentityProviders: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.ssoDomainIdentityProviders.getSsoDomainIdentityProviders,
    queryKeyFn: ssoDomainIdentityProviderKeys.list,
  }),
  createSsoDomainIdentityProvider: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.ssoDomainIdentityProviders.createSsoDomainIdentityProvider,
    mutationKey: [
      "ssoDomainIdentityProviders",
      "createSsoDomainIdentityProvider",
    ],
  }),
  updateSsoDomainIdentityProvider: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.ssoDomainIdentityProviders.updateSsoDomainIdentityProvider,
    mutationKey: [
      "ssoDomainIdentityProviders",
      "updateSsoDomainIdentityProvider",
    ],
  }),
  deleteSsoDomainIdentityProvider: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.ssoDomainIdentityProviders.deleteSsoDomainIdentityProvider,
    mutationKey: [
      "ssoDomainIdentityProviders",
      "deleteSsoDomainIdentityProvider",
    ],
  }),
};

export { ssoDomainIdentityProviderKeys };
